export const primaryColor = '#FAF9F6';
export const primaryBgColor = '#DC143C';
export const secondaryBgColor = '#FAF9F6';
export const ForeColorYellow = "#D50032";
export const ForeColorPurple = "#36454F";


export const ForeColorBlack = "#301934";
export const ForeColorWhite = "#FAF9F6";
